import {IFreePlayVoucherData} from "../../../../common/interfaces/free-play/free-play-voucher-data.interface";
import {IFreePlayVoucherModel} from "../vouchers/free-play-voucher.model.interface";
import {FP_VOUCHER_TYPES} from "../../../../common/const/free_play_consts";
import {FreePlayVoucherModel} from "../vouchers/free-play/free-play-voucher.model";
import {JackpotFreePlayVoucherModel} from "../vouchers/jackpot-free-play/jackpot-free-play-voucher.model";
import {FreeSpinsVoucherModel} from "../vouchers/free-spins/free-spins-voucher.model";
import {JackpotFreeSpinsVoucherModel} from "../vouchers/jackpot-free-spins/jackpot-free-spins-voucher.model";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {DisposableObject} from "../../../../utils/disposable-object";

export class VouchersProviderBase extends DisposableObject  {
    constructor(protected readonly services: IServiceFactoryExtended) {
        super();
    }

    protected _createVoucherModel(voucherData: IFreePlayVoucherData): IFreePlayVoucherModel | null {
        switch (voucherData.FreePlayTypeId) {
            case FP_VOUCHER_TYPES.FreePlay:
                return new FreePlayVoucherModel(voucherData, this.services);
            case FP_VOUCHER_TYPES.FreeJackpotPlay:
                return new JackpotFreePlayVoucherModel(voucherData, this.services);
            case FP_VOUCHER_TYPES.FreeSpin:
                return new FreeSpinsVoucherModel(voucherData, this.services);
            case FP_VOUCHER_TYPES.FreeJackpotSpin:
                return new JackpotFreeSpinsVoucherModel(voucherData, this.services);
            default:
                this.services.logger.error(`Invalid voucher type ${voucherData.FreePlayTypeId}`);
                return null;
        }
    }
}